import apiClient from '@lib/apiClient';
import { AssignSystemToCustomerRequest, AssignSystemToCustomerResponse, Customer, GetCustomerSystemsRequest, GetCustomerSystemsResponse, GetIngestionHistoryResponse, GetSystemCustomerAssociationsResponse, ListCustomersRequest, ListCustomersResponse, ListUnassignedSystemsQuery, ListUnassignedSystemsResponse, TriggerIngestionRequest, TriggerIngestionResponse } from '@features/customers/domain/customer.types';
import { assignSystemToCustomerResponsesSchema, getCustomerSystemsResponseSchema, getSystemCustomerAssociationsResponseSchema, listCustomersResponseSchema, listUnassignedSystemsResponseSchema } from '@features/customers/domain/customer.schemas';

const API_BASE_URL = '/customers';

export const customerService = {
  listCustomers: async (request: ListCustomersRequest = {}): Promise<ListCustomersResponse> => {
    const response = await apiClient.get(
      `${API_BASE_URL}`,
      {params: request}
    );
    return listCustomersResponseSchema.parse(response.data);
  },

  getCustomerById: async (customerId: string): Promise<Customer> => {
    const response = await apiClient.get<Customer>(
      `${API_BASE_URL}/${customerId}`
    );
    return response.data;
  },

  getCustomerSystems: async (request: GetCustomerSystemsRequest): Promise<GetCustomerSystemsResponse> => {
    const {customerId, ...params} = request;
    const response = await apiClient.get(
      `${API_BASE_URL}/${customerId}/systems`,
      {params}
    );
    return getCustomerSystemsResponseSchema.parse(response.data);
  },

  getSystemCustomerAssociations: async (systemId: string): Promise<GetSystemCustomerAssociationsResponse> => {
    const response = await apiClient.get(
      `${API_BASE_URL}/systems/${systemId}/owner`
    );
    return getSystemCustomerAssociationsResponseSchema.parse(response.data);
  },

  getIngestionHistory: async (take: number = 10): Promise<GetIngestionHistoryResponse> => {
    const response = await apiClient.get<GetIngestionHistoryResponse>(
      `${API_BASE_URL}/ingestion-history`,
      {params: {take}}
    );
    return response.data;
  },

  triggerExternalDataIngestion: async (request: TriggerIngestionRequest): Promise<TriggerIngestionResponse> => {
    const response = await apiClient.post<TriggerIngestionResponse>(
      `${API_BASE_URL}/trigger-ingestion`,
      request
    );
    return response.data;
  },

  assignSystemToCustomer: async (request: AssignSystemToCustomerRequest): Promise<Array<AssignSystemToCustomerResponse>> => {
    const response = await apiClient.put(
      `${API_BASE_URL}/systems/assign`,
      request
    );
    return assignSystemToCustomerResponsesSchema.parse(response.data);
  },

  getUnassignedSystems: async (request: ListUnassignedSystemsQuery = {}): Promise<ListUnassignedSystemsResponse> => {
    const response = await apiClient.get(
      `${API_BASE_URL}/systems/unassigned`,
      {params: request}
    );
    return listUnassignedSystemsResponseSchema.parse(response.data);
  },

  toggleFavoriteCustomer: async (customerId: string): Promise<boolean> => {
    const response = await apiClient.post<boolean>(
      `/users/me/favorites/customers/${customerId}/toggle`
    );
    return response.data;
  },
};